import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule], // Add CommonModule here
  template: `
    <div style="display: flex; justify-content: center; align-items: center; height: 100vh; font-family: Arial, sans-serif;">
      <h1>Loading...</h1>
    </div>
  `,
  styleUrl: './loading.component.css' // You can add actual loading CSS here
})
export class LoadingComponent { }